import { View } from 'backbone.marionette';
import _ from 'lodash';

import DeliveryScheduleGridView from '../../../../common/views/DeliveryScheduleGridView';

import tmplMaintenanceDeliveryView from './MaintenanceDeliveryView.hbs';

const MaintenanceDeliveryView = View.extend({
  template: tmplMaintenanceDeliveryView,

  className: 'maintenance-delivery-view',

  ui: {
    deliveryGrid: '.delivery-grid',
    deliveryInfoError: '.delivery-info-error'
  },

  regions: {
    deliveryGrid: '@ui.deliveryGrid'
  },

  onRender() {
    const deliveryGrid = new DeliveryScheduleGridView({
      objectTypeCode: 'ORDER',
      objectID: this.model.get('orderDetails').orderId,
      gridName: 'deliveryScheduleGrid',
      model: this.model,
      editable: !this.model.get('isReadOnly')
    });
    this.showChildView('deliveryGrid', deliveryGrid);
    deliveryGrid.getViewGrid().sort('clin', 'ascending');
  },

  validate() {
    let isValid = true;
    const coll = this.getDeliveryData();
    const reqFields = [
      'deliveryPOCName',
      'deliveryPOCEmail',
      'deliveryPOCPhone',
      'network',
      'addressLine1',
      'buildingFloorNumber',
      'floorNumber',
      'city',
      'regionName',
      'zip'
    ];
    _.each(coll, (item) => {
      _.each(reqFields, (field) => {
        if (!item[field] && !item.address[field]) {
          isValid = false;
          this.ui.deliveryInfoError.show();
        }
      });
    });
    isValid ? this.trigger('no:errors') : this.trigger('has:errors');
    return isValid;
  },

  async getDeliveryGridCSV(isTemplate) {
    const deliveryGrid = this.getChildView('deliveryGrid');
    if (isTemplate) {
      return await deliveryGrid.downloadTemplateCSV();
    } else {
      return await deliveryGrid.generateAndDownloadCSV();
    }
  },

  getDeliveryData() {
    this.ui.deliveryInfoError.hide();
    this.trigger('no:errors');
    const coll = this.getChildView('deliveryGrid').model.get('schedules');
    return coll;
  }
});

export default MaintenanceDeliveryView;
